import PropTypes from 'prop-types';

import { Box, Paper, Skeleton } from '@mui/material';

const TextSkeleton = () => (
  <Skeleton width="10rem" height="2rem" variant="text" />
);
const FullWidthTextSkeleton = () => (
  <Skeleton width="100%" height="2rem" variant="text" />
);
const ProfileSkeleton = () => (
  <Skeleton
    width="4rem"
    height="4rem"
    variant="rounded"
    sx={{ borderRadius: '1rem' }}
  />
);
const Spacer = () => <Box my="2rem" />;

const PostSkeleton = ({ customStyles }) => (
  <Paper
    elevation={0}
    sx={{
      padding: { xs: '2rem 2rem', md: '2rem 4rem' },
      marginY: '2rem',
      height: '20rem',
      borderRadius: '1rem',
      ...customStyles,
    }}
  >
    <Box display="flex" gap="1rem" width="100%">
      <ProfileSkeleton />
      <Box display="flex" flexDirection="column" justifyContent="space-evenly">
        <TextSkeleton />
        <TextSkeleton />
      </Box>
      <Box flexGrow={1} />
      <TextSkeleton />
    </Box>
    <Spacer />
    <FullWidthTextSkeleton />
    <FullWidthTextSkeleton />
    <Spacer />
    <Box display="flex" gap="1rem" width="100%">
      <TextSkeleton />
      <TextSkeleton />
    </Box>
  </Paper>
);

PostSkeleton.propTypes = {
  customStyles: PropTypes.instanceOf(Object),
};

const CommentSkeleton = () => (
  <Paper
    elevation={0}
    sx={{
      marginY: '2rem',
      height: '10rem',
      borderRadius: '1rem',
    }}
  >
    <Box display="flex" gap="1rem" width="100%">
      <ProfileSkeleton />
      <Box display="flex" flexDirection="column" justifyContent="space-evenly">
        <TextSkeleton />
        <TextSkeleton />
      </Box>
      <Box flexGrow={1} />
      <TextSkeleton />
    </Box>
    <Spacer />
    <FullWidthTextSkeleton />
    <FullWidthTextSkeleton />
  </Paper>
);

const CommunitySkeleton = () => (
  <Box sx={{ width: '100%' }}>
    <Box sx={{ width: '100%', height: '4rem', display: 'flex', gap: '1rem' }}>
      <Skeleton sx={{ width: '50%', height: '4rem' }} variant="rounded" />
      <Skeleton sx={{ flexGrow: 1, height: '4rem' }} variant="rounded" />
      <Skeleton sx={{ width: '12rem', height: '4rem' }} variant="rounded" />
    </Box>
    <Spacer />
    <Box sx={{ display: 'flex', gap: '2rem' }}>
      <Box
        sx={{
          width: { xs: '100%', sm: '60%' },
          display: 'flex',
          flexDirection: 'column',
          gap: '2rem',
        }}
      >
        <Skeleton sx={{ width: '100%', height: '7rem' }} variant="rounded" />
        {Array.from({ length: 5 }).map((v, i) => (
          <PostSkeleton key={i} customStyles={{ margin: 0 }} />
        ))}
      </Box>
      <Box
        sx={{
          minWidth: '16rem',
          height: '50vh',
          flexGrow: 1,
          display: { xs: 'none', sm: 'block' },
        }}
      >
        <Skeleton sx={{ width: '100%', height: '100%' }} variant="rounded" />
      </Box>
    </Box>
  </Box>
);

const LinkCommunitySkeleton = () => (
  <Box sx={{ height: '30rem', width: '100%' }}>
    {Array.from({ length: 5 }).map((v, i) => (
      <Box
        key={i}
        sx={{
          height: '5rem',
          width: '100%',
          borderBottom: '.1rem solid #e0e0e0',
          display: 'flex',
        }}
      >
        <Box
          sx={{
            width: '4.2rem',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Skeleton sx={{ width: '2rem', height: '2rem' }} variant="rounded" />
        </Box>
        <Box sx={{ display: 'flex', gap: '1rem', width: '100%' }}>
          <Box sx={{ width: '40%', display: 'flex', alignItems: 'center' }}>
            <Skeleton sx={{ width: '60%', height: '2rem' }} variant="rounded" />
          </Box>
        </Box>
      </Box>
    ))}
  </Box>
);

export {
  TextSkeleton,
  FullWidthTextSkeleton,
  ProfileSkeleton,
  Spacer,
  PostSkeleton,
  CommentSkeleton,
  CommunitySkeleton,
  LinkCommunitySkeleton,
};
